export default "__VITE_ASSET__1bfd8278__"